@if (showBanner) {
  <div>
    <svg [routerLink]="['/home']" class="button" id="banner" xmlns="http://www.w3.org/2000/svg" width="18" height="18"
      viewBox="0 0 18 18">
      <path id="Tracé_10032" data-name="Tracé 10032" d="M0,0H18V18H0Z" fill="none" />
      <path id="Tracé_10033" data-name="Tracé 10033" d="M7.5,15V10.5h3V15h3.75V9H16.5L9,2.25,1.5,9H3.75v6Z" fill="#fff" />
    </svg>
    <span>{{ banner }}</span>
  </div>
}
